import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Asset, BaseAssetFragment, BaseCalendarEventFragment, CalendarEventForScheduleFragment, FindQuery, JobDetailsV2Fragment, Job_CalendarEventFragment } from 'graphql.generated';
import { ActionSource } from 'src/app/state/action-sources';

export interface PlaceholderEventInfo {
   id: string;
   type: string;
   title: string;
   start: number;
   assets: Asset[];
   end?: number;
   //always empty, used just for correct rendering event placeholder
   locations?: Location[];
   products?: [];
}

export const BookEventDialogActions = createActionGroup({
   source: ActionSource.BOOK_EVENT_DIALOG,
   events: {
      'Dialog Opened': props<{
         job: JobDetailsV2Fragment;
         event: Job_CalendarEventFragment;
         zoneEstimateLength: number;
         zoneVoseLength: number;
         zoneIncludeDockTravel: boolean;
      }>(),
      'Open Book Dialog Button Clicked': props<{
         event: BaseCalendarEventFragment,
         reschedule?: boolean,
      }>(),
      'Close Book Dialog Button Clicked': emptyProps(),
      'Date Selected': props<{ date: string }>(),
      'Find Availability Requested': emptyProps(),
      'Find Availability Success': props<{
        windows: FindQuery['find']['windows'];
        timezone: string;
      }>(),
      'Find Availability Error': props<{ error: Error }>(),
      'Time Selected': props<{ time: string }>(),
      'Available Assets Set': props<{ availableAssets: BaseAssetFragment[] }>(),
      'Assets Selected': props<{ assetIds: string[] }>(),
      'Time With Timezone Selected': props<{
         time: string;
         timezone: string;
      }>(),
      'Placeholder Timing Calculated': props<{
         placeholderEventInfo: PlaceholderEventInfo,
         selectedAssetsIds: string[],
      }>(),
      'Book Button Clicked': emptyProps(),
      'Reschedule Button Clicked': emptyProps(),
      'Save As Button Clicked': emptyProps(),
      'Book Event Success': props<{
         updatedEvent: CalendarEventForScheduleFragment;
         jobId: string;
      }>(),
      'Book Event Error': props<{ error: Error }>(),
      'Reschedule Event Success': props<{
         updatedEvent: CalendarEventForScheduleFragment;
         jobId: string;
      }>(),
      'Reschedule Event Error': props<{ error: Error }>(),
      'Update Event Button Clicked': emptyProps(),
      'Book Smart Consult For Default Admin Email Confirmation Button Clicked': emptyProps(),
      'Book Smart Consult For Default Admin Email Cancel Button Clicked': emptyProps(),
      'Book Virtual Estimate Without Video Call Confirmation Button Clicked': emptyProps(),
      'Book Virtual Estimate Without Video Call Cancel Button Clicked': emptyProps(),
      'Integrations Conflict Confirmation Shown': emptyProps(),
      'Integrations Conflict Confirmation Error': props<{ error: Error }>(),
      'Virtual Estimate Ready For Booking': emptyProps(),
      'Escape Key Pressed': emptyProps(),
    },
});
